import React, {useEffect, useState} from 'react'
import {Button, Divider, Typography} from "antd";
import Tour from "reactour";
import {checkFirstTimeDashboardUser} from "../../app/util";

const {Title} = Typography


export default (props) => {
    const [open, setOpen] = useState(false)
    const [stepNum, setStepNum] = useState(0)
    const [curNum, setCurNum] = useState(0)

    useEffect(()=>{
        if (window !== undefined) {
            let open = checkFirstTimeDashboardUser(props)
            setOpen(open)
        }
    }, [])

    const StepView1 = () => {
        return (
            <>
                <iframe width="560" style={{maxWidth: '100%'}} height="315"
                        src="https://www.youtube.com/embed/FheSpVSccwY"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                ></iframe>
                <center>
                    <Title level={1} style={{fontSize: 12, marginTop: 12}}>Welcome to RevArt! 👋</Title>
                    <p style={{lineHeight: '2rem'}}>Hey, we're thrilled to have you here! <br/>
                        Welcome to RevArt SMART Manager! You can view the little video up above to get started on your trip and take full use of the tools and opportunities we have waiting for you! </p>
                </center>
                <BottomActionFirstView/>
            </>
        )
    }

    const BottomActionFirstView = () => {
        return (
            <>
                <Divider/>
                <div style={{display: 'flex'}}>
                    <Button type={'text'} style={{marginLeft: 12, marginRight: 'auto'}}
                            onClick={() => setOpen(false)}>Skip</Button>
                    <span style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: 8
                    }}>{`${curNum} of ${steps.length}`}</span>
                    <Button type={'primary'} style={{marginLeft: 'auto', marginRight: 12, fontWeight: "bold"}}
                            onClick={() => {
                                setStepNum(1)
                            }}>Take the tour</Button>
                </div>
            </>
        )
    }

    const BottomActionLastView = () => {
        return (
            <>
                <Divider/>
                <div style={{display: 'flex'}}>
                    <Button type={'text'} style={{marginLeft: 12, marginRight: 'auto'}}
                            onClick={() => setStepNum(1)}>Restart</Button>
                    <Button type={'primary'} style={{marginLeft: 'auto', marginRight: 12, fontWeight: "bold"}}
                            onClick={() => {
                                setOpen(false)
                                setStepNum(0)
                            }}>Done</Button>
                </div>
            </>
        )
    }

    const BasicLayout = ({children}) => {
        return <div>
            {children}
        </div>
    }

    const BottomActionView = () => {
        return (
            <>
                <Divider/>
                <div style={{display: 'flex', verticalAlign: 'middle'}}>
                    <Button type={'text'} style={{marginLeft: 12, marginRight: 'auto'}}
                            onClick={() => setStepNum(Math.max(stepNum - 1, 0))}>Prev</Button>
                    <span style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: 8
                    }}>{`${curNum} of ${steps.length}`}</span>
                    <Button type={'primary'} style={{marginLeft: 'auto', marginRight: 12, fontWeight: "bold"}}
                            onClick={() => {
                                setStepNum(stepNum + 1)
                            }}>Next</Button>
                </div>
            </>
        )
    }

    const TitleText = ({title}) => {
        return <center><Typography style={{fontSize: 24, fontWeight: "bold"}}>{title}</Typography></center>
    }

    const ParaText = ({children}) => {
        return (
            <p style={{marginTop: 12}}>{children}</p>
        )
    }

    const steps = [
        {
            target: '',
            content: () => {
                return <BasicLayout><StepView1/></BasicLayout>
            }
        },
        {
            selector: '#reactour__pieces_parent',
            content: <BasicLayout>
                <TitleText title={'Pieces'}></TitleText>
                <ParaText>Artworks and their information can be edited, cataloged, and stored here.</ParaText>
                <BottomActionView/>
            </BasicLayout>,
        },
        {
            selector: '#reactour__showcase_parent',
            content: <BasicLayout>
                <TitleText title={'Showcase'}></TitleText>
                <ParaText>Create a website for your portfolio here so that viewers may learn about your work, experiences, and most recent news!
                </ParaText>
                <BottomActionView/>
            </BasicLayout>,
        },
        {
            selector: '#reactour__income_parent',
            content: <BasicLayout>
                <TitleText title={'Income'}></TitleText>
                <ParaText>Keep track of your art's orders and sales. Understand how much money you have made.</ParaText>
                <BottomActionView/>
            </BasicLayout>,
        },
        {
            selector: '#reactour__document_parent',
            content: <BasicLayout>
                <TitleText title={'Document'}></TitleText>
                <ParaText>Access sample contracts here to electronically sign with your customers.</ParaText>
                <BottomActionView/>
            </BasicLayout>,
        },
        {
            selector: '#reactour__contact_parent',
            content: <BasicLayout>
                <TitleText title={'Contact'}></TitleText>
                <ParaText>Keep track of your contacts here so you never miss an opportunity to connect professionally.</ParaText>
                <BottomActionLastView/>
            </BasicLayout>,
        },
    ]

    return (
        <>
            <Tour
                rounded={5}
                isOpen={open}
                goToStep={stepNum}
                className={'my-tour'}
                accentColor={'#0531ad'}
                badgeContent={(curr, tot) => {if (curr !== curNum) setCurNum(curr); return `${curr} of ${tot}`}}
                disableDotsNavigation={true}
                onAfterOpen={(target) => (document.body.style.overflowY = 'hidden')}
                onBeforeClose={(target) => (document.body.style.overflowY = 'auto')}
                onRequestClose={() => {
                    setOpen(false);
                    setStepNum(0)
                }}
                prevButton={() => {
                    return null
                }}
                nextButton={() => {
                    return null
                }}
                showNavigation={true}
                steps={steps}/>
        </>
    )
}